const hexToRGB = (hex: string, alpha?: number): string => {
  let hexColor = hex;

  // If a three-character hexcolor, make six-character
  if (hexColor.length === 3) {
    hexColor = hexColor
      .split('')
      .map((h) => {
        return h + h;
      })
      .join('');
  }
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return `rgb(${r}, ${g}, ${b})`;
};

export default hexToRGB;
